module.exports = __webpack_public_path__ + "static/media/hms_login.070c178b.svg";